import http from '@/uteis/http'

export default class DadosSessaoService {
  async buscarDadosSessao (clientId) {
    var url = '/d0593/pae-back/v1/controles/sessao'

    return await http.get(url, { params: { id: clientId } }).then(response => {
      return response.data
    }).catch(error => {
      console.log(error)
    })
  }

  // Verificar se usa em algum lugar
  async refreshToken () {
    var url = '/d0593/pae-back/v1/apiControllerSessao/refresh'

    return await http.get(url).then(response => {
      return response.data
    }).catch(error => {
      console.log(error)
    })
  }
}
